import root from 'window-or-global';
import {breakpoints} from '../constants';
import NavActions from '../actions';
import {getOuterWidth, getWindowWidth, getWindowHeight} from 'epic-common/src/browser';

let running = false;
let maxRightNavWidth = -1;
let lastWindowWidth = 0;
let needToVerifyCollapsedDesktop = false;

const closeStuff = () => {
    NavActions.closeMobileTablet.defer();
    NavActions.mobileUserActive.defer(false);
    NavActions.searchActive.defer(false);
};

const widthsCache = {
    desktop: {},
    collapsed: {}
};

const getWidths = () => {
    //using refs couldn't get the widths early enough in componentDidMount. using getELementById() instead
    const widths = {
        egLogo: getOuterWidth('egLogo'),
        propLogo: getOuterWidth('propLogo'),
        navLine: getOuterWidth('navLine'),
        rightNav: getOuterWidth('rightNav'),
        siteNav: getOuterWidth('siteNav') //siteNav width is 0 when in tablet mode
    };
    return widths;
};

const validateSiteNavWidth = (state = {}) => {
    const windowWidth = getWindowWidth();
    const currentWidths = getWidths();
    let mode = '';

    if (state.isDesktop && !state.collapsedDesktop) {
        mode = 'desktop';
        widthsCache.desktop = currentWidths;
    } else if (state.isDesktop && state.collapsedDesktop) {
        mode = 'collapsed';
        widthsCache.collapsed = currentWidths;
    } else if (state.isTablet) {
        mode = 'tablet';
        const prevSiteNavWidth = widthsCache.collapsed.siteNav || widthsCache.desktop.siteNav;
        if (prevSiteNavWidth) {
            currentWidths.siteNav = prevSiteNavWidth;
        }
    } else if (state.isMobile) {
        mode = 'mobile';
        const prevSiteNavWidth = widthsCache.collapsed.siteNav || widthsCache.desktop.siteNav;
        if (prevSiteNavWidth) {
            currentWidths.siteNav = prevSiteNavWidth;
        }
    }

    let maxWidth = 0;
    for (const key in currentWidths) {
        if (typeof key === 'string') {
            const width = currentWidths[key];
            maxWidth += width;
        }
    }

    /*
    if (process.env.NODE_ENV !== 'production') {
        console.debug('mode: ', mode);
        console.debug('maxWidth: ', maxWidth);
        console.debug('windowWidth: ', windowWidth);
    }*/

    return {mode, maxWidth, notEnoughRoom: windowWidth <= maxWidth, fits: windowWidth > maxWidth};
};

const validateRightNavWidth = (state = {}) => {
    const windowWidth = getWindowWidth();
    if (state.isTablet) {
        const egLogoWidth = getOuterWidth('egLogo');
        maxRightNavWidth = windowWidth - egLogoWidth - 20; //extra 20 pixel leeway
    }
    return maxRightNavWidth;
};


export function updateDimensions(state = {}, stateChangeCallback, noChangeCallback) {
    if (running) return;
    running = true;

    const windowWidth = getWindowWidth();

    let isMobile = false;
    let isTablet = false;
    let isDesktop = false;
    let collapsedDesktop = state.collapsedDesktop;

    let needWidthReCalc = false;

    if (windowWidth < breakpoints.mobile) {
        isMobile = true;
        collapsedDesktop = false;
    } else {
        const {notEnoughRoom, fits} = validateSiteNavWidth(state);

        //checking to make sure collapsed desktop worked
        if (needToVerifyCollapsedDesktop) {
            needToVerifyCollapsedDesktop = false;
            if (fits) {
                isDesktop = true;
                collapsedDesktop = true;
            } else {
                isTablet = true;
            }
        } else if (windowWidth > breakpoints.collapseTarget) { //eligible for collapseTarget
            if (!collapsedDesktop && notEnoughRoom) { //collapsedDesktop might work
                isDesktop = true;
                collapsedDesktop = true;
                needToVerifyCollapsedDesktop = true;
                needWidthReCalc = true; //may need tablet
            } else if (collapsedDesktop && notEnoughRoom) { //collapsedDesktop didnt fit. go tablet
                collapsedDesktop = false;
                isTablet = true;
                validateRightNavWidth();
            } else if (!collapsedDesktop && fits && !state.isTablet) {
                isDesktop = true;
                collapsedDesktop = false;
            } else if (!collapsedDesktop && fits && state.isTablet) {
                isDesktop = true;
                collapsedDesktop = false;
                needWidthReCalc = true; //may fit whole sitenav
            } else if (collapsedDesktop && fits) {
                isDesktop = true;
                if (lastWindowWidth < windowWidth) {
                    collapsedDesktop = false;
                    needWidthReCalc = true; //may fit whole sitenav
                }
            }
        } else {
            isTablet = true;
            validateRightNavWidth();
        }

        closeStuff();
        lastWindowWidth = windowWidth;
    }

    if (state.isMobile !== isMobile
        || state.isTablet !== isTablet
        || state.isDesktop !== isDesktop
        || state.collapsedDesktop !== collapsedDesktop) {
        stateChangeCallback({
            isMobile,
            isTablet,
            isDesktop,
            collapsedDesktop,
            needWidthReCalc
        });
    } else {
        noChangeCallback();
    }

    running = false;
}

export function getSiteNavMobileHeight() {
    const iconBar = root.document.getElementById('iconBar') || {clientHeight: 0};
    const eghAlert = root.document.getElementById('eghAlert') || {clientHeight: 0};
    const epicGamesNav = root.document.getElementById('egh') || {clientHeight: 0};
    const cta = root.document.getElementById('cta') || {clientHeight: 0};
    const totalHeight = getWindowHeight();
    //console.debug(totalHeight);
    const siteNavHeight = totalHeight - iconBar.clientHeight - epicGamesNav.clientHeight - cta.clientHeight - eghAlert.clientHeight;

    return siteNavHeight;
}
